@if(this.isLoading()) {
    <div class="flex justify-center items-center h-[128px]">
        <mat-spinner diameter="80" />
    </div>
} @else if(this.selectedTourPoint) {
    <div class="w-full background list-container min-h-screen grey-border header">
            <div class="pt-[8px] inner">
                <div class="mb-1 background grid grid-cols-12 gap-2 select-all-text-black">
                    <button
                        mat-icon-button
                        class="!flex items-center justify-center col-span-2"
                        (click)="closeDetailsDrawer()"
                        (keypress)="closeDetailsDrawer()"
                        i18n-aria-label
                        aria-label="close transport order details"
                        role="button"
                    >
                        <lib-app-icon
                            id="close-transport-order-details"
                            icon="arrow_left"
                            className="value"
                            [size]="'24x24'"
                        />
                    </button>
                    <div class="col-span-10 min-w-0">
                        <h2 class="drawer-title mat-subtitle-1 " i18n>
                            {{ this.selectedTourPoint.name }}
                        </h2>
                        @if (this.selectedTourPoint.customerTourNumber || this.selectedTourPoint.loadingReference) {
                            <div class="flex items-center gap-x-1 min-w-0 text-sm font-medium leading-[20px] tracking-[0.1px]">
                                @if (this.selectedTourPoint.customerTourNumber) {
                                    <span class="grey-label shrink-0" i18n>Tour:</span>
                                    <span class="point-value-black truncate grow shrink-0 basis-[5ch] max-w-max" [title]="this.selectedTourPoint.customerTourNumber">{{this.selectedTourPoint.customerTourNumber}}</span>
                                }
                                @if (this.selectedTourPoint.customerTourNumber && this.selectedTourPoint.loadingReference) {
                                    <span class="grey-label shrink-0">-</span>
                                }
                                @if (this.selectedTourPoint.loadingReference) {
                                    <span class="grey-label shrink-0" i18n>Booking:</span>
                                    <span class="point-value-black truncate min-w-0" [title]="this.selectedTourPoint.loadingReference">{{this.selectedTourPoint.loadingReference}}</span>
                                }
                            </div>
                        }
                    </div>
                   
                </div>
                <div class="mt-[12px] ml-[16px] flex gap-1 mb-3 items-center pl-[16px] pr-[16px]">
                    <input
                        type="checkbox"
                        class="tour-point-checkbox"
                        [checked]="selectAll()"
                        [disabled]="this.isDisabled()"
                        (change)="onSelectAllChange($event)"
                    />
                    <span i18n class="selectAllText ml-1 select-all-text-black">
                        Choose everything
                    </span>
                    <!-- <mat-checkbox i18n class="tour-point-checkbox">Choose everything</mat-checkbox> -->
                </div>
                <div class="border-line ml-[16px] mr-[16px] mb-[8px]">
                    <mat-divider></mat-divider>
                </div>
            </div>
            <div
                class="tourpoint-details-list scrollable"
                [class.blur-sm]="getIsSilentUpdateInProgress()"
                [class.pointer-events-none]="getIsSilentUpdateInProgress()"
                cdkScrollable
                cdkDropList
                [cdkDropListData]="this.detailsTourPoints()"
                [cdkDropListSortPredicate]="canSortToIndex"
                (cdkDropListDropped)="onDrop($event)"
                cdkScrollable
                >
            @for (legTourPoint of this.detailsTourPoints(); track legTourPoint.legId) {
                <div
                    class="flex items-center draggable-item background-details"
                    cdkDrag
                    [cdkDragData]="legTourPoint"
                    [cdkDragDisabled]="this.shouldDisableReordering()"
                >
                    <div class="flex items-start container grid grid-cols-12 gap-1 ml-7">
                        <div class="pt-3 checkbox-column !col-span-1 mt-0.5" >
                            <input 
                                type="checkbox"
                                [disabled]="this.isDisabled()"
                                class="tour-point-checkbox"
                                [checked]="legTourPoint.checked"
                                (change)="onLegTourPointCheckedChange($event, legTourPoint)"
                            />
                            <div class="tour-point-order grey-border">
                                {{legTourPoint.order}}
                            </div>
                        </div>
                        <cal-leg-tour-point
                            class="!col-span-11"
                            [legTourPoint]="legTourPoint" 
                            [iconType]="getIconName(legTourPoint.trafficIcon)"
                            [isDisabled]="this.isDisabled()"
                            [isEligibleForLoadingLegs]="!!this.selectedTourPoint.isEligibleForLoadingLegs"
                        />
                    </div>
                </div>
                <mat-divider class="!ml-2"></mat-divider>
            }
            </div>
        @if(!this.isDisabled()) {
            <div class="flex justify-end mr-[16px] mb-1">
                <button
                    i18n
                    [className]="(hasItemsSelectedForRemoval() ? 'remove-button-background-color' : 'remove-button-desabled-color') + ' remove-button'"
                    (click)="removeSelected()"
                    [disabled]="!hasItemsSelectedForRemoval()"
                >
                    Remove
                </button>
            </div>
        }
    </div>
}